import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-Calendar',
  standalone: true,
  templateUrl: '../../assets/Calendar.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamCalendarIcon {}
